<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path opacity="0.4" d="M12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24Z" fill="#FFDECC"/>
<path d="M10.4881 17.1362C10.7161 17.1362 10.9441 17.0522 11.1241 16.8722L15.3601 12.6362C15.7081 12.2882 15.7081 11.7122 15.3601 11.3642L11.1241 7.12819C10.7761 6.78019 10.2001 6.78019 9.85209 7.12819C9.50409 7.47619 9.50409 8.05219 9.85209 8.40019L13.4521 12.0002L9.85209 15.6002C9.50409 15.9482 9.50409 16.5242 9.85209 16.8722C10.0201 17.0522 10.2481 17.1362 10.4881 17.1362Z" fill="#FF5C00"/>
</svg>

</template>
  

